import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Table, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';

import { atualizastatus } from '../../../../actions/pedidos/pedidos';

const Pedidos  = (props) => {

    const handleAtivaPedido = async () => {

        const dt = new Date();
        dt.setDate(5);
        const pedido = {
            idpromotora: props.match.params.idpromotora,
            idevento: props.match.params.idevento,
            idparalelo: props.credencial.pedido.idparalelo,
            idstatus: 1,
            vencto: moment(dt).format("YY-MM-DD")        
        }

        await props.atualizastatus(pedido)
        await props.load();
    }
        
    return (
        <Card.Body>
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Vencimento</th>
                        <th>Produto</th>                
                    </tr>
                </thead>
                <tbody>
                    {props.credencial?props.credencial.pedido.inscritoitensescolhidos.map(produtos => {
                        const dt = new Date(props.credencial.pedido.vencto);
                        return (
                        <tr key={produtos.idsubitems}>
                            <td>{produtos.idparalelo}</td>                
                            <td>{moment(dt).format("DD/MM/YY")}</td>
                            <td>{produtos.sub_itens.descricaoprecos}</td>
                        </tr>
                        );
                    }):null}
                </tbody>
            </Table>
            {props.credencial&&props.credencial.pedido.idstatus!=1&&props.credencial.pedido.idstatus!=2?
                <Button className="mt-2" variant="primary" size="lg" block onClick={handleAtivaPedido}>
                    Reativar
                </Button>
                :
                <Alert variant="success" block>
                    <Alert.Heading>Pedido Ativo</Alert.Heading>
                </Alert>
            }
        </Card.Body>
    );
}

const mapStateToProps = (state) => {
    return {
        credencial: state.pesquisaCredencialComPedidoReducer[0]?state.pesquisaCredencialComPedidoReducer[0]:{}
    }
}

export default connect(mapStateToProps,{atualizastatus})(withRouter(Pedidos));